<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <nav class="bar tabbar" v-show="this.$route.meta.tabBar">
      <a class="tab-index router" :class="{active:this.$route.meta.home}" @click="changeTab('home')">首页</a>
      <a class="tab-my router" :class="{active:this.$route.meta.my}" @click="changeTab('my')">我的</a>
    </nav>
  </div>
</template>

<script>
import * as wx from 'lib/Wx'
import * as Util from 'lib/Util'
export default {
  name: 'app',
  data() {
     return{
        event: '',
     }
  },
  created(){
      this.wxPromise = wx.ready();
      this.setShare();
  },
  watch: {
      '$route': async function() {
          //this.wxPromise = wx.ready();
          this.setShare();
          //this.$layer.close();
      }
  },
  methods: {
    // v-touch:swiperight="onSwipeRight"
    onSwipeRight(){
        this.$router.go(-1);
        return false;
    },
    changeTab(type){
      this.$router.push({name: type})
    },
    async setShare(config) {
        config = Util.shareConfig(config);
        if (DEBUG) {
            console.log(config);
        }
        let wxInstance = await this.wxPromise;
        wxInstance.onMenuShareTimeline(config);
        wxInstance.onMenuShareAppMessage(config);
        wxInstance.onMenuShareQQ(config);
        wxInstance.onMenuShareWeibo(config);
        wxInstance.onMenuShareQZone(config);
    }
  },
}
</script>

<style lang="less" rel="stylesheet/less">
  html, body, div, span, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  abbr, address, cite, code,
  del, dfn, em, img, ins, kbd, q, samp,
  small, strong, sub, sup, var,
  b, i,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    vertical-align: baseline;
    background: transparent;
  }

  body {
    line-height: 1;
    height: 100%;
  }
  hide { display:none; }
  img {width:100%;height:auto;}
  :focus {
    outline: 1;
  }

  article, aside, canvas, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section, summary {
    display: block;
  }

  nav ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  a {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    background: transparent;
    text-decoration: none;
  }

  ins {
    background-color: #ff9;
    color: #000;
    text-decoration: none;
  }

  mark {
    background-color: #ff9;
    color: #000;
    font-style: italic;
    font-weight: bold;
  }

  del {
    text-decoration: line-through;
  }

  abbr[title], dfn[title] {
    border-bottom: 1px dotted #000;
    cursor: help;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #cccccc;
    margin: 1em 0;
    padding: 0;
  }

  input, select {
    vertical-align: middle;
  }

  ul, ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }
@color-blue:#129aee;
  #app {
    position: relative;
    height: 100%;
    width: 750px;
    margin: 0 auto;
    background-color: #fff;
  }
  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    user-select: none;
  }
  /*common style*/
  a {color:@color-blue;}
  .lastspace {
    //margin-bottom:98px !important;
  }
  .container {
    position: absolute;
    left:0;
    top: 0;
    right: 0;
    bottom: 0;
    height:100vh;
    background:#f5f5f5;

  }
  .font-dark {
    color:#111111;
  }
  .font-light {
    color:#666666;
  }
  .normal-font {
    font-size:28px;
    .font-light;
  }



  .section {
    padding:0;
    margin-bottom:20px;
    background: #fff;
    &.ul {
      padding-left:24px;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top:solid 1px #e3e3e3; /*no*/
        box-sizing: border-box;
        height:88px;
        line-height:88px;
        font-size:32px;
        padding-right:24px;
        .font-dark;
        & > a {
          display: flex;
          flex:auto;
          justify-content: space-between;
          .font-dark;
        }
        &:first-child {border:none}
        &.follow {
          padding-left:70px;
          background: url("assets/icon_my_follow@2x.png") 10px center no-repeat;
          background-size: 50px 50px;
        }
        &.quest {
          padding-left:70px;
          background: url("assets/icon_my_quest@2x.png") 10px center no-repeat;
          background-size: 50px 50px;
        }
        &.bindphone {
          padding-left:70px;
          background: url("assets/icon_my_bindphone@2x.png") 10px center no-repeat;
          background-size: 50px 50px;
        }
        &.help {
          padding-left:70px;
          background: url("assets/icon_my_help@2x.png") 10px center no-repeat;
          background-size: 50px 50px;
        }
        &.connect {
          padding-left:70px;
          background: url("assets/icon_connect_phone@2x.png") 10px center no-repeat;
          background-size: 50px 50px;
        }
        .right-content {
          text-align:right;
          font-size:32px;
          .font-dark;
          &.arr {
            min-width:12px;
            min-height:20px;
            padding-right:40px;
            background: url("assets/icon_list_grey_rightarrow@2x.png") right center no-repeat;
            background-size: 12px 20px;
          }
        }
      }

    }

  }
  .cls {
    box-sizing: border-box;
    height:90px;
    line-height: 50px;
    font-size:34px;
    font-weight: normal;
    padding:20px 24px 20px 64px;
    &.ing  {
      background: url(assets/icon_xin@2x.png) 24px center no-repeat;
      background-size: 26px 26px;
    }
    &.end {
      background: url(assets/icon_star@2x.png) 24px center no-repeat;
      background-size: 26px 26px;
    }
    &.quest  {
      background: url(assets/icon_quest@2x.png) 24px center no-repeat;
      background-size: 26px 26px;
    }
    &.answer  {
      background: url(assets/icon_answer@2x.png) 24px center no-repeat;
      background-size: 26px 26px;
    }
  }
  /*bottom bar*/
  .bar {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    height:98px;
    width:750px;
    display: flex;
    flex-direction: row;
  }
  /*nav bar*/
  .tabbar {
    background: #f8f8f8;
    justify-content: space-between;
    align-items: center;
    border-top:solid 1px #cccccc; /*no*/
  }
  .tabbar a {
    flex:1;
    align-self: center;
    text-align:center;
    padding-top:60px;
    color:#777777;
    font-size:22px;
    &.active {
      color:@color-blue;
    }
  }

  .tab-index {
    background: url(assets/tab_1_normal@2x.png) center 8px no-repeat;
    background-size: 50px 50px;
    &.active{
      background: url(assets/tab_1_selected@2x.png) center 8px no-repeat;
      background-size: 50px 50px;
    }
  }
  .tab-my {
    background: url(assets/tab_2_normal@2x.png) center 8px no-repeat;
    background-size: 50px 50px;
    &.active {
      background: url(assets/tab_2_selected@2x.png) center 8px no-repeat;
      background-size: 50px 50px;
    }
  }

  /*ask bar*/
  .btn-bar {
    background: @color-blue;
    justify-content: center;
    align-items: center;
    align-self: center;
    font-size:36px;
    color:#ffffff;
  }
  /*common btns*/
  .btn {
    align-self: center;
    height:56px; /*px*/
    line-height: 56px; /*px*/
    font-size:28px; 
    text-align:center;
    border-radius: 28px;
    background: #fff;
    margin-left:auto;
    width:auto;
    border:solid 1px @color-blue; /*no*/
    &.btn-ask {
      color:@color-blue;
      flex:none;
      width:150px;
    }
    &.btn-end {
      color:#fff;
      border:solid 1px #ccc; /*no*/
      background:#ccc;
      width:150px;
    }
    &.btn-small {
      padding:0 15px;
      color:@color-blue;
      font-size:22px;
      height:36px;
      line-height: 36px;
      border-radius: 18px;
    }
  }

  .btn-zan {
    color:@color-blue;
    border:solid 1px @color-blue; /*no*/
    width: 90px;
    height: 90px;
    border-radius: 45px;
    background: #fff;
    text-align: center;
    font-size: 28px;
    line-height: 90px;
    display: block;
    margin:auto;
  }

  /*doctor info box*/
  .section {
    padding:0;
    margin-bottom:20px;
    background: #fff;
  }

  .box {
    padding:40px 24px;
    border-top:solid 1px #eeeeee; /*no*/
    .title {
      font-size:36px;
      font-weight:bold;
      margin-bottom:40px;
      .font-dark;
    }
  }
  .list-box {
    .title {
      display: flex;
      flex-direction: column;
      .quest-list-title {
        font-size:32px;
        .font-dark;
        line-height:40px;
      }
      .quest-list-time {
        font-size:28px;
        margin-top:20px;
        .font-light
      }
    }
  }

  .doctor-box {
    display: flex;
    justify-content: flex-start;
    .avatar {
      width:120px;
      height:120px;
      border-radius: 60px;
      overflow: hidden;
      text-align:center;
      flex:none;
      margin-right:24px;
      &.small {
        width:72px;
        height:72px;
        align-self: flex-start;
        margin-right:16px;
      }
      & > img {
        vertical-align: center;
      }
    }
    .doctor-info {
      display: flex;
      flex-direction:column;
      justify-content: space-between;
      .doctor-name {
        font-size:32px;
        font-weight: bold;
        margin-right:40px;
        .font-dark;
      }
      .doctor-title, .doctor-hospital {
        font-size:28px;
        .font-light;
      }
      .doctor-quest-count {
        font-size:28px;
        .font-light;
      }
    }
    .doctor-tip {
      position: relative;
      flex:auto;
      margin-left:20px;
      padding:24px;
      border:solid 1px #e3e3e3;
      border-radius: 50px;
      font-size:28px;
      line-height: 40px;
      word-wrap:break-word;
      word-break:break-all;
      .font-light;
    }
    .icon-tip {
      background: url('assets/tiparrow@2x.png') center center no-repeat;
      background-size: 14px 15px;
      position: absolute;
      left:-14px;
      top:50px;
      width:14px;
      height:15px;
    }
    .doctor-answer {
      position: relative;
      flex:auto;
      margin-left:20px;
      padding:24px;
      border:solid 1px @color-blue; /*no*/
      border-radius: 50px;
      font-size:32px;
      background-color: @color-blue;
      line-height: 40px;
      color:#fff;
      word-wrap:break-word;
      word-break:break-all;
    }
    .icon-answer {
      background: url('assets/answerarrow@2x.png') center center no-repeat;
      background-size: 14px 15px;
      position: absolute;
      left:-14px;
      top:50px;
      width:14px;
      height:15px;
    }
    .doctor-answer-share {
      height:88px;
      background: url('assets/icon_answer_share@2x.png') left center no-repeat;
      background-size: 95px 88px;
      padding-left:94px;
      margin-left:20px;
    }
    .doctor-answer-share-content {
      color:#fff;
      font-size:32px;
      line-height: 88px;
      border-top-right-radius: 44px;
      border-bottom-right-radius: 44px;
      background: @color-blue;
      padding-left:20px;
      min-width: 280px;
      height:100%;
    }
  }
  .doctor-desc {
    font-size:28px;
    line-height:35px;
    .font-light;
    overflow:hidden;
    text-overflow:ellipsis; 
    -o-text-overflow:ellipsis;
    white-space:nowrap;
  }

  .event-box {
    border:none;
    display: flex;
    flex-direction:column;
    .title {
      font-size:36px;
      .font-dark;
    }
    .event-info{
      display: flex;
      align-items: center;
      margin:30px 0;
      margin-top:-15px;
    }
    .event-time{
      font-size:28px;
      .font-light;
    }
    .event-desc {
      font-size:28px;
      line-height: 40px;
      .font-light;
      .event-support {
        margin-top:20px;
        font-size:28px;
        .font-light;
      }
    }


  }
  .userquest-box {
    display: flex;
    flex-direction:column;
    .user-info{
      display: flex;
      align-items: center;
      margin-bottom:40px;
      font-size:26px;
      .font-light;
    }
    .btn {margin-left:30px;}
    .userquest-content{
      font-size:32px;
      line-height:40px;
      .font-dark;
    }
  }
  .answer-box {
    border:none;
    display: flex;
    flex-direction:column;
    .answer-time {
      font-size:26px;
      .font-light;
    }
    .answer-no {
      font-size:28px;
      color:@color-blue;
    }
    &.noanswer {
      flex-direction:row;
      justify-content: space-between;
    }
    .doctor-box + .answer-time {margin-top:40px;}
    .answer-share-tip {
      margin-top:40px;
      .normal-font;
      line-height:40px;
    }
  }

  .user-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .avatar {
      display: flex;
      justify-content: center;
      align-items: center;
      width:126px;
      height:126px;
      border-radius: 63px;
      overflow: hidden;
      text-align:center;
      flex:none;
      background-color: rgba(255,255,255,0.3);
      margin-right:40px;
      & > img {
        width:118px;
        height:118px;
        border-radius: 59px;
      }

    }
    .user-name {
      font-size:40px;
      color:#fff;
    }
  }

  /*form element*/
  .form {
    padding:0 24px;
    display: flex;
    flex-direction:column;
  }
  .textarea-box {
     background:#f5f5f5;
     min-height:380px;
     position: relative;
     padding:24px;
     .textarea {
       resize:none;
       width:100%;
       height: 350px;
       overflow-y: auto;
       font-size:32px;
       line-height: 40px;
       background: none;
       -webkit-appearance: none;
       border:none;
     }
     .textarea-count {
       color:#666;
       font-size: 24px;
       position: absolute;
       bottom:24px;
       right:24px;
       text-align: right;

     }
   }
  .checkbox-group {
    .font-light;
    li {
      font-size:26px;
      padding:10px 0;
    }
    .checkbox {
      display: block;
      float: left;
      margin-right: 12px;
      width:26px;
      height:26px;
      background: url(assets/checkbox_normal@2x.png) center center no-repeat;
      background-size: 26px;
    }
    .checked {
      .checkbox; background: url('assets/checkbox_checked@2x.png') center center no-repeat;
      background-size: 26px;
    }
  }

/*ad*/
  .carousel-indicators { text-align: right !important;}
  .carousel-dot {
    text-indent: 100000px !important;
    width:16px !important;
    height:16px !important;
    margin:8px !important;
    border-radius: 8px;
    background: rgba(51,51,51,0.3) !important;
    &.active {
      background: rgba(255,255,255,1) !important;
    }
    &:last-child {margin-right:24px !important;}
  }
 .router {
    cursor:pointer;
  }

  input,
  textarea {
    user-select: text;
  }
  @import "less/vue-layer-mobile-ui.less";
</style>



// WEBPACK FOOTER //
// App.vue?dc0bfbba